import {LocalSettingManager} from "biewangle";

export const Remember = LocalSettingManager.config({
    deviceId: -1,
    base: '192.168.168.1',
    hideDishCode: false,
    hideDishPriceIsZero: true,
    localLangs: 'de'
})
